import { GridItem, RadioGroup, Radio } from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { useField } from "formik";
import { Trans, useTranslation } from "react-i18next";

import { DocumentInfo } from "./DocumentInfo";

export function AustraliaRightToWorkInputField({
  field: config,
}: {
  field: components["schemas"]["AustraliaRightToWorkCheckField"];
}) {
  const { t } = useTranslation();
  const [, meta, helpers] = useField(config.name);

  const handleCitizenshipChange = (value: string) => {
    helpers.setValue({
      id: "",
      document_type: "",
      document_number: "",
      document_issuing_country: value === "yes" ? "AU" : "",
    });
  };

  return (
    <>
      <GridItem>
        <RadioGroup
          direction="column"
          label={t("Are you an Australian citizen?")}
          value={
            !meta.value
              ? ""
              : meta.value.document_issuing_country === "AU"
                ? "yes"
                : "no"
          }
          name={config.name}
          isRequired
          aria-label={config.name + " radio button selections"}
          onChange={handleCitizenshipChange}
          errorMessage={typeof meta.error === "string" && meta.error}
          testID="australia-right-to-work-radio-group"
        >
          <Radio value="yes" testID="australia-right-to-work-yes-radio-button">
            <Trans>Yes, I am an Australian citizen</Trans>
          </Radio>
          <Radio value="no" testID="australia-right-to-work-no-radio-button">
            <Trans>No, I am not an Australian citizen</Trans>
          </Radio>
        </RadioGroup>
      </GridItem>

      {meta.value && (
        <DocumentInfo
          name={config.name}
          isCitizen={meta.value.document_issuing_country === "AU"}
        />
      )}
    </>
  );
}
